import React from 'react'
import PropTypes from 'prop-types'
import { TIRES_LANDING_PAGE } from 'constant'
import styled, { css } from 'styled-components'
import Link from 'components/common/Link/Link'
import {
  LOOKING_FOR_TIRE_PRICES_MESSAGE,
  LOOKING_FOR_TIRE_PRICES_ID,
  SHOP_TIRES_MESSAGE
} from './constants'

const LookingForTirePrices = ({ servicesDrawer }) =>
  <LookingForTirePricesWrapper id={ LOOKING_FOR_TIRE_PRICES_ID } addMarginBottom={ servicesDrawer }>
    <LookingForTirePricesText>{ LOOKING_FOR_TIRE_PRICES_MESSAGE }</LookingForTirePricesText>
    &nbsp;
    <LookingForTirePricesLink
      to={ TIRES_LANDING_PAGE }
      data-action="goToInternalHref">
      { SHOP_TIRES_MESSAGE }
    </LookingForTirePricesLink>
  </LookingForTirePricesWrapper>

LookingForTirePrices.propTypes = {
  servicesDrawer: PropTypes.bool
}

export default LookingForTirePrices

const LookingForTirePricesWrapper = styled.div`
  margin: 15px 0 0 35px;
  ${props => props.addMarginBottom && css`
    margin-bottom: 15px;
  `}
`

const LookingForTirePricesText = styled.span`
  font-style: italic;
`

const LookingForTirePricesLink = styled(Link)`
  font-weight: bold;
`
